
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BPTCoursePage: React.FC = () => {
  const courseData = {
    title: "Bachelor of Physiotherapy",
    shortName: "BPT",
    duration: "4.5 years",
    description: "A comprehensive undergraduate program in physiotherapy focusing on physical rehabilitation, movement therapy, and patient care.",
    overview: "Bachelor of Physiotherapy (BPT) is a 4.5-year undergraduate healthcare degree program that focuses on physical therapy, rehabilitation medicine, and movement sciences. The program combines theoretical knowledge with extensive practical training to prepare students for careers in physiotherapy and rehabilitation healthcare. Students learn about human anatomy, exercise therapy, electrotherapy, and various rehabilitation techniques.",
    eligibility: [
      "12th grade with Physics, Chemistry, Biology (PCB)",
      "Minimum 50% aggregate marks (45% for SC/ST/OBC)",
      "Age: 17-25 years (relaxation for reserved categories)",
      "Some institutions may require entrance exams"
    ],
    careerProspects: {
      roles: [
        "Physiotherapist",
        "Rehabilitation Specialist", 
        "Sports Therapist",
        "Orthopedic Physiotherapist",
        "Neurological Physiotherapist",
        "Pediatric Physiotherapist",
        "Cardio-Pulmonary Physiotherapist",
        "Community Health Physiotherapist"
      ],
      industries: [
        "Hospitals and Healthcare Centers",
        "Rehabilitation Centers",
        "Sports Medicine Clinics", 
        "Nursing Homes",
        "Fitness Centers",
        "Private Practice",
        "Home Healthcare Services",
        "Research Institutions"
      ],
      averageSalary: "₹2,50,000 - ₹7,00,000 per year",
      topRecruiters: [
        "Apollo Hospitals",
        "Fortis Healthcare",
        "Max Healthcare",
        "AIIMS",
        "Government Hospitals",
        "Sports Authority of India",
        "Private Physiotherapy Clinics",
        "Rehabilitation Centers"
      ]
    },
    curriculum: [
      {
        year: 1,
        subjects: [
          "Human Anatomy",
          "Human Physiology",
          "Biochemistry",
          "Psychology",
          "Sociology",
          "Basic Physiotherapy"
        ]
      },
      {
        year: 2, 
        subjects: [
          "Pathology",
          "Microbiology",
          "Pharmacology",
          "Exercise Therapy",
          "Electrotherapy",
          "Biomechanics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Orthopedic Medicine",
          "Neurological Conditions",
          "Cardio-Pulmonary Physiotherapy",
          "Community Medicine",
          "Research Methodology",
          "Clinical Physiotherapy"
        ]
      },
      {
        year: 4,
        subjects: [
          "Sports Medicine",
          "Pediatric Physiotherapy",
          "Geriatric Physiotherapy",
          "Occupational Health",
          "Clinical Postings",
          "Rehabilitation Medicine"
        ]
      },
      {
        year: 5,
        subjects: [
          "Internship Program",
          "Clinical Rotations",
          "Specialized Training",
          "Case Studies",
          "Professional Practice",
          "Research Project"
        ]
      }
    ],
    admissionProcess: [
      "Complete 12th grade with required subjects",
      "Appear for state/national entrance exams (if required)",
      "Apply to colleges based on merit/entrance scores",
      "Participate in counseling process",
      "Document verification and medical fitness",
      "Fee payment and admission confirmation"
    ],
    topColleges: [
      { 
        name: "Jamia Millia Islamia", 
        location: "New Delhi", 
        fees: "₹80,000/year",
        ranking: "1"
      },
      { 
        name: "Christian Medical College", 
        location: "Vellore", 
        fees: "₹1,20,000/year",
        ranking: "2"
      },
      { 
        name: "Manipal College of Allied Health Sciences", 
        location: "Karnataka", 
        fees: "₹2,50,000/year",
        ranking: "3"
      },
      { 
        name: "JSS College of Physiotherapy", 
        location: "Karnataka", 
        fees: "₹1,80,000/year",
        ranking: "4"
      },
      { 
        name: "King George's Medical University", 
        location: "Lucknow", 
        fees: "₹90,000/year",
        ranking: "5"
      },
      { 
        name: "Punjabi University", 
        location: "Punjab", 
        fees: "₹70,000/year",
        ranking: "6"
      }
    ],
    skills: [
      "Manual therapy techniques",
      "Patient assessment and evaluation", 
      "Exercise prescription",
      "Communication skills",
      "Empathy and patience",
      "Problem-solving abilities",
      "Knowledge of anatomy and physiology",
      "Equipment operation skills"
    ],
    futureScope: "BPT graduates have excellent career opportunities in the growing healthcare sector. They can pursue higher studies like MPT (Master of Physiotherapy), specialize in various fields, start private practice, work in sports medicine, or pursue research careers. The scope includes hospital employment, rehabilitation centers, sports teams, and international opportunities.",
    faqs: [
      {
        question: "What is the duration of BPT course?",
        answer: "BPT is a 4.5-year course, which includes 4 years of academic study and 6 months of mandatory internship training in various physiotherapy departments."
      },
      {
        question: "Is BPT a good career option?",
        answer: "Yes, BPT offers excellent career prospects with growing demand for physiotherapy services. It provides opportunities for private practice, hospital employment, sports medicine, and specialization options."
      },
      {
        question: "What are the specialization options after BPT?",
        answer: "After BPT, you can pursue MPT specializations in Orthopedics, Neurology, Cardio-Pulmonary, Sports Physiotherapy, Pediatrics, and Community Physiotherapy."
      },
      {
        question: "Can I start my own physiotherapy clinic after BPT?",
        answer: "Yes, after completing BPT and the mandatory internship, you can register with the physiotherapy council and start your own practice. Many graduates successfully run private clinics."
      },
      {
        question: "What is the scope of BPT abroad?",
        answer: "BPT graduates can work abroad, but most countries require additional licensing exams or certifications. Countries like USA, Canada, Australia, and UK have good opportunities for qualified physiotherapists."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BPTCoursePage;
